module.exports = __webpack_public_path__ + "static/media/dpl1.png.23e87d97.jpg";